import { NgModule, isDevMode } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { RouteReuseStrategy } from '@angular/router';
import { HTTP_INTERCEPTORS, provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { IonicModule, IonicRouteStrategy } from '@ionic/angular';
import { AppComponent } from './app.component';
import { AppRoutingModule } from './app-routing.module';
import { InterceptorService } from './lib/services/interceptor.service';
import { Geolocation } from '@awesome-cordova-plugins/geolocation/ngx';
import { CommonApi } from './lib/services/api/common.api';
import { SharedModule } from "src/app/components/shared.module";
import { InAppBrowser } from '@awesome-cordova-plugins/in-app-browser/ngx';
import { FormsModule } from '@angular/forms';

// Import storage module
import { Drivers } from '@ionic/storage';
import { IonicStorageModule } from '@ionic/storage-angular';
import * as CordovaSQLiteDriver from 'localforage-cordovasqlitedriver';
import { NotificationService } from './lib/services/notification.service';
import { initializeApp, provideFirebaseApp } from '@angular/fire/app';
import { environment } from 'src/environments/environment';
import { getMessaging, provideMessaging } from '@angular/fire/messaging';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { ToastrModule } from 'ngx-toastr';
import { PipeModule } from './lib/pipe/pipes.module';
import { ImageCropperComponent } from 'ngx-image-cropper';
import { CropImageComponent } from './pages/user/crop-image/crop-image.component';
import { ServiceWorkerModule } from '@angular/service-worker';

@NgModule({
  declarations: [
    AppComponent,
    CropImageComponent
  ],
  bootstrap: [AppComponent],
  imports: [
    PipeModule,
    BrowserModule,
    BrowserAnimationsModule,
    ToastrModule.forRoot(),
    IonicModule.forRoot(),
    IonicStorageModule.forRoot({
      name: '__userdb',
      driverOrder: [CordovaSQLiteDriver._driver, Drivers.IndexedDB, Drivers.LocalStorage],
    }),
    AppRoutingModule,
    SharedModule,
    FormsModule,
    ImageCropperComponent,
    ServiceWorkerModule.register('ngsw-worker.js', {
      enabled: environment.enableServiceWorker,
      // Register the ServiceWorker as soon as the application is stable
      // or after 30 seconds (whichever comes first).
      registrationStrategy: 'registerWhenStable:30000'
    })
  ],
  providers: [
    { provide: RouteReuseStrategy, useClass: IonicRouteStrategy },
    CommonApi,
    { provide: HTTP_INTERCEPTORS, useClass: InterceptorService, multi: true },
    provideFirebaseApp(() => initializeApp(environment.firebaseConfig)),
    provideMessaging(() => getMessaging()),
    NotificationService,
    Geolocation,
    InAppBrowser,
    Storage,
    provideHttpClient(withInterceptorsFromDi())
  ]
})
export class AppModule { }
